export default "__VITE_ASSET__2f69b7ae__"